import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import PlanPage from '../pages/customer/PlanPage';

export default function CustomerRoutes() {
  return (
    <Routes>
      {/* The parent route in App.tsx already includes /:expertUrl/* */}
      {/* Public landing page */}
      <Route index element={<PlanPage />} />
      {/* Redirect any unknown routes to the plan page */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
